module.exports = __webpack_public_path__ + "img/tway-logotipo-gris-byline-2.8b6101d5.svg";